import React from "react";
import { Link } from "react-router-dom";

export default function ShowReviewQuote({ showData }) {
  return (
    <>
      {showData?.review_quote && (
        <div className="show-quote">
          <div className="show-quote-text">
            {showData?.review_credit ? "“" : null}
            {showData?.review_quote}
            {showData?.review_credit ? "”" : null}
          </div>
          {showData?.review_credit ? (
            <div className="show-quote-author">{`~ ${showData?.review_credit}`}</div>
          ) : null}
        </div>
      )}
    </>
  );
}
